import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import { ToastContainer, toast } from 'react-toastify';
import pdficon from "./pdf.png";
import bgImage from './bg16.png'; // Ensure this path is correct
import logo from './Logos.png'; // Logo import
import { min } from 'moment/moment.js';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
function EditVehicleTracking() {
    const { id } = useParams(); // Get the vehicle ID from URL
    const navigate = useNavigate();
    const token = localStorage.getItem('authToken'); // Get token from localStorage
    const userProfile = JSON.parse(localStorage.getItem('userProfile')); // Get user profile from localStorage  
    const userBMID = userProfile ? userProfile.emp_code : null; // Get BM ID from user profile
    const isUserITadmin = userProfile ? userProfile.is_it_admin : null; // Check if user is IT admin

    // const [vehicle, setVehicle] = useState({
    //     emp_code: '',
    //     comp_name: '',
    //     dept_name: '',
    //     designation_name: '',
    //     mobile: '',
    //     location_name: '',
    //     bank_name: '',
    //     bank_acnum: '',
    //     ifsc_code: '',
    //     rpt_mgr: '',
    //     audit_mngr: '',
    //     vehicle_type: '',
    //     vehicle_number: '',
    //     driver_name: '',
    //     driver_mobile: '',
    //     route: '',
    //     otp: '',
    //     created_at: ''
    // });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [ImgRows, setImgRows] = useState([]);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_BASE_URL1 = process.env.REACT_APP_API_BASE_URL1;
    const [uploadError, setUploadError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [isFileAttached, setIsFileAttached] = useState(false);
    const [routeList, setRouteList] = useState([]);
    const [vehicleType, setVehicleType] = useState([]);
    const [isFromDraft, setIsFormDraft] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [branchManagers, setBranchManagers] = useState([]);
    const [formData, setFormData] = useState({
        rpt_mgr_status: '',
        audit_status: '',
        accounts_status: '',
        comp_name: '',
        emp_code: '',
        grade: '',
        dept_name: '',
        designation_name: '',
        report_mngr: '',
        bank_acnum: '',
        bank_name: '',
        ifsc_code: '',
        location_name: '',
        vehicle_type: '',
        inhouse_vehicle: '',
        vehicle_number: '',
        driver_name: '',
        driver_mobile: '',
        route: '',
        is_submitted: '',
        branch_manager_bmid: '0',
        branch_manager_name: '',
        branch_manager_remarks: '',
        branch_manager_approval: 'Pending',
        branch_manager_approved_on: '',
        store_remarks: '',
        OTPverified_on: '',
        img: [],
        new_img: [],
    });

    const handleBackClick = () => {
        navigate("/vehicle_tracking");
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'inhouse_vehicle' && value === 'External') {
            //reset vehicle number and type when switching to External
            setFormData(prevState => ({
                ...prevState,
                vehicle_number: '',
                vehicle_type: ''
            }));
        }

        if (name === 'vehicle_number' && value) {
            const vehicle = vehicleNumbers.find(v => v.vehicle_number === value);
            if (vehicle) {
                setFormData(prevState => ({
                    ...prevState,
                    [name]: value,
                    vehicle_type: vehicle.vehicle_type
                }));
                return;
            }
        }

        // Validate driver mobile number
        if (name === 'driver_mobile' && value) {
            // Only validate if 10 digits have been entered
            if (value.length === 10 && !validateMobile(value)) {
                toast.error("Please enter a valid mobile number.");
                return;
            }
        }


        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    //validate driver mobile number
    const validateMobile = (number) => {
        // Example: Validate 10-digit Indian mobile numbers
        const mobileRegex = /^[6-9]\d{9}$/;
        return mobileRegex.test(number);
    };

    const handlePrint = () => {
        window.print();
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const MAX_SIZE = 1 * 1024 * 1024; // 1MB in bytes

        let errorMsg = "";
        const validFiles = files.filter(file => {
            if (file.size > MAX_SIZE) {
                errorMsg = `File "${file.name}" exceeds the 1MB limit. Please upload a smaller file.`;
                return false;
            }
            return true;
        });

        if (errorMsg) {
            setUploadError(errorMsg); // Show error message above button
            toast.error(errorMsg); // Also show toast
            //  setIsSubmitAllowed(false); // Prevent submission
        } else {
            setUploadError(""); // Clear error if no issue
            //  setIsSubmitAllowed(true); // Allow submission
        }

        if (validFiles.length === 0) return; // Stop if all files are invalid

        // Convert valid files to Base64
        const fileReaders = validFiles.map(file => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        });

        Promise.all(fileReaders)
            .then(base64Files => {
                setFormData(prevData => ({
                    ...prevData,
                    new_img: base64Files
                }));
                setIsFileAttached(true); // Set flag to true if files are attached
            })
            .catch(error => {
                console.error("Error reading files:", error);
            });
    };
    useEffect(() => {
        setLoading(true);
        const fetchVehicleNumbers = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}getVehicleNumbers`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                if (result.status) {
                    setVehicleNumbers(result.data);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        };
        fetchVehicleNumbers();
    }, []);

    useEffect(() => {
        setLoading(true);
        const fetchBranchManagers = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}getemployee`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const result = await response.json();
                console.log("Branch managers:", result); // Log to check fetched data
                if (result.status) {
                    setBranchManagers(result.data);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        };
        fetchBranchManagers();
    }, []);


    useEffect(() => {
        setLoading(true);
        const fetchRoutes = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}get_routes`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });

                const data = await response.json();
                if (data.status && Array.isArray(data.data)) {
                    setRouteList(data.data);
                }
            } catch (err) {
                console.error("Error fetching routes:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchRoutes();
    }, []);

    // Fetch the vehicle details using the API
    const fetchVehicleData = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}vehicle_tracking_byid/${id}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();

            if (data.status === true) {
                setError('');
                setFormData(data.data);
                //set img rows to the images array from the response
                setImgRows(data.data.img);
                setLoading(false);
                //if data.data.img length is greater than 0, set isFileAttached to true
                if (data.data.img.length > 0) {
                    setIsFileAttached(true);
                }
            } else {
                //if error is Token has been invalidated then logout the user and redirect to login page with message
                if (data.error === 'Token has been invalidated') {
                    localStorage.removeItem('authToken');
                    toast.error('Your session has expired. Please login again.');
                    navigate('/');
                    return;
                }
                setError('Vehicle not found');
                setLoading(false);
            }
        } catch (err) {
            console.error('Error fetching vehicle data:', err);
            setError('Error fetching vehicle data');
            setLoading(false);
        }
    };
    useEffect(() => {
        setLoading(true);
        fetchVehicleData();
    }, [id, token]);

    // Handle the form submission to update the vehicle details
    // prevent default form submission behavior
    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        if (isSubmitting) return;

        try {
            setIsSubmitting(true);
            setError('');
            console.log('Form data before submission:', formData); // Log the form data
            const response = await fetch(
                `${API_BASE_URL}update_vehicle_track/${id}`,
                {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                }
            );

            const data = await response.json();

            if (data.status) {
                fetchVehicleData();
                toast.success('Vehicle updated successfully');
                //if formData.is_submitted = yes then execute popupOtpSent function
                if (formData.is_submitted === 'yes') {
                    popupOtpSent();
                }
            } else {
                setError(data.message || 'Failed to update vehicle');
                toast.error(data.message || 'Failed to update vehicle');
            }
        } catch (err) {
            console.error('Error updating vehicle:', err);
            setError('Error updating vehicle');
            toast.error('Error updating vehicle');
        } finally {
            setIsSubmitting(false);
        }
    };

    // Handle input changes

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Only update one state to avoid infinite loops
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const popupOtpSent = () => {
        // Call api send driver mobile number to send OTP
        const driverMobile = formData.driver_mobile;
        const otp = formData.otp;
        //api sms_store_vehicle_otp, use try catch to handle errors
        fetch(`${API_BASE_URL}sms_store_vehicle_otp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ driver_mobile: driverMobile, otp: otp }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status) {
                    alert('OTP sent successfully! ' + data.data.otp);
                    const otp = prompt('Please enter the OTP sent to your mobile number:');
                    if (otp === formData.otp) {
                        // call api verify_store_vehicle_otp sending otp and formData.vehicle_id
                        fetch(`${API_BASE_URL}verify_store_vehicle_otp`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${token}`,
                            },
                            body: JSON.stringify({ otp: otp, vehicle_id: id }),
                        })
                            .then((response) => response.json())
                            .then((data) => {
                                if (data.status === true) {
                                    fetchVehicleData();
                                    //add delay before print using setTimeout
                                    setTimeout(() => {
                                        alert('OTP verified successfully!');
                                        handlePrint(); // Call the print function after delay
                                    }, 1000); // 1 second delay
                                    //navigate('/vehicle_tracking'); // Redirect to vehicle tracking page
                                }
                                else {
                                    alert('Invalid OTP. Please try again.');
                                }
                            })
                            .catch((error) => {
                                console.error('Error verifying OTP:', error);
                                alert('Error verifying OTP. Please try again.');
                            });
                    } else if (otp === null) {
                        alert('OTP verification cancelled.');

                    } else if (otp === '') {
                        alert('Please enter the OTP sent to your mobile number.');

                    } else {
                        alert('Invalid OTP. Please try again.');
                    }

                } else {
                    setError(data.message || 'Failed to send OTP');
                    toast.error(data.message || 'Failed to send OTP');
                }
            })
            .catch((error) => {
                console.error('Error sending OTP:', error);
                setError('Error sending OTP');
                toast.error('Error sending OTP');
            });
    }

    const handleOtpSubmit = async (e) => {
    }

    const Loader = () => (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <p>Loading...</p>
        </div>
    );
    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0" style={{ fontSize: '20px' }}>Edit Vehicle Tracking</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                        <li className="breadcrumb-item active">Edit Vehicle Tracking</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    {loading ? (
                        <Loader />
                    ) : error ? (
                        <p>{error}</p>
                    ) : (
                        <section className="col-lg-12 ">
                            <div className="login-logo-new print-only">
                                <img src={logo} alt="Travel App" style={{  minWidth: '50em', height: 'auto' }} />
                                <br />
                                <h3 className=''> Store Vehicle Form </h3>
                            </div>

                            <div className="card" style={{ borderTop: '3px solid #CC5500' }}>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                            <div className="box-body">
                                                {/* <div className="row"> <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label className="myLabel">Employee Code</label>
                                                        <input
                                                            type="text"
                                                            className="form-control input-font"
                                                            name="emp_code"
                                                            value={formData.emp_code}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="myLabel">Company Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control input-font"
                                                                name="comp_name"
                                                                value={formData.comp_name}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="myLabel">Department Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control input-font"
                                                                name="dept_name"
                                                                value={formData.dept_name}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="myLabel">Designation Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control input-font"
                                                                name="designation_name"
                                                                value={formData.designation_name}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="myLabel">Mobile</label>
                                                            <input
                                                                type="text"
                                                                className="form-control input-font"
                                                                name="mobile"
                                                                value={formData.mobile}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="myLabel">Vehicle Type</label>
                                                            <input
                                                                type="text"
                                                                className="form-control input-font"
                                                                name="vehicle_type"
                                                                value={formData.vehicle_type}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>

                                                </div> */}
                                                <div className='row'>
                                                    {/* <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="myLabel">Vehicle Number</label>
                                                            <input
                                                                type="text"
                                                                className="form-control input-font"
                                                                name="vehicle_number"
                                                                value={formData.vehicle_number}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="myLabel">Driver Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control input-font"
                                                                name="driver_name"
                                                                value={formData.driver_name}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="myLabel">Driver Mobile</label>
                                                            <input
                                                                type="text"
                                                                className="form-control input-font"
                                                                name="driver_mobile"
                                                                value={formData.driver_mobile}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="myLabel">Route</label>

                                                            <select
                                                                name="route"
                                                                id="route"
                                                                value={formData.route}
                                                                onChange={handleChange}
                                                                className="form-control input-font"
                                                            >
                                                                <option value="">-- Select --</option>
                                                                {routeList.map((item, index) => (
                                                                    <option key={index} value={item.route_name}>
                                                                        {item.route_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div> */}
                                                    {/* <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="myLabel">Created At</label>
                                                            <input
                                                                type="text"
                                                                className="form-control input-font"
                                                                name="created_at"
                                                                value={formData.created_at}
                                                                onChange={handleChange}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div> */}
                                                    {/* <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label htmlFor="name">Branch Manager
                                                            </label>
                                                            <select
                                                                name="branch_manager_bmid"
                                                                id="branch_manager_bmid"
                                                                value={formData.branch_manager_bmid}
                                                                onChange={handleChange}
                                                                className="form-control input-font"
                                                                required
                                                            >
                                                                <option value="">-- Select --</option>
                                                                {branchManagers.map((item, index) => (
                                                                    <option key={index} value={item.emp_code}>
                                                                        {item.comp_name} ({item.emp_code})
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label htmlFor="vehicle_type">Inhouse Vehicle </label>
                                                        <select
                                                            name="inhouse_vehicle"
                                                            id="inhouse_vehicle"
                                                            value={formData.inhouse_vehicle}
                                                            onChange={handleChange}
                                                            className="form-control input-font"
                                                        >
                                                            <option value="">-- Select --</option>
                                                            <option value="InHouse">InHouse</option>
                                                            <option value="External">External</option>
                                                        </select>
                                                    </div>
                                                </div>


                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label htmlFor="vehicle_number">Vehicle Number
                                                        </label>
                                                        {formData.inhouse_vehicle === "External" ? (
                                                            <input
                                                                type="text"
                                                                name="vehicle_number"
                                                                id="vehicle_number"
                                                                value={formData.vehicle_number}
                                                                placeholder='Enter Vehicle Number'
                                                                onChange={handleChange}
                                                                className="form-control input-font"

                                                            />)
                                                            :
                                                            <select
                                                                name="vehicle_number"
                                                                id="vehicle_number"
                                                                value={formData.vehicle_number}
                                                                onChange={handleChange}
                                                                className="form-control input-font"

                                                            >
                                                                <option value="">-- Select --</option>
                                                                {vehicleNumbers.map((item, index) => (
                                                                    <option key={index} value={item.vehicle_number}>
                                                                        {item.vehicle_number}
                                                                    </option>
                                                                ))}
                                                            </select>}
                                                    </div>
                                                </div>

                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label htmlFor="vehicle_type">Vehicle Type</label>
                                                        <select
                                                            name="vehicle_type"
                                                            id="vehicle_type"
                                                            value={formData.vehicle_type}
                                                            onChange={handleChange}
                                                            className="form-control input-font"
                                                        >
                                                            <option value="">-- Select --</option>
                                                            <option value="Car">Car</option>
                                                            <option value="Ambulance">Ambulance</option>
                                                            <option value="Auto">Auto</option>
                                                            <option value="Transport-Vehicle-4-Wheeler">Transport-Vehicle-4-Wheeler</option>
                                                            <option value="Transport-Vehicle-3-Wheeler">Transport-Vehicle-3-Wheeler</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label htmlFor="driver_name">Driver Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="driver_name"
                                                            id="driver_name"
                                                            value={formData.driver_name}
                                                            placeholder='Enter Driver Name'
                                                            onChange={handleChange}
                                                            className="form-control input-font"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label htmlFor="driver_mobile">Driver Mobile
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="driver_mobile"
                                                            id="driver_mobile"
                                                            placeholder='Enter Driver Mobile'
                                                            value={formData.driver_mobile}
                                                            onChange={handleChange}
                                                            className="form-control input-font"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label htmlFor="driver_licence">Remarks </label>
                                                        <textarea
                                                            name="store_remarks"
                                                            id="store_remarks"
                                                            value={formData.store_remarks}
                                                            onChange={handleChange}
                                                            className="form-control input-font"
                                                            rows="1"
                                                            required
                                                        ></textarea>
                                                    </div>
                                                </div>
                                                        
                                                            <div className="col-md-2 print-only">

                                                                <div className="form-group ">
                                                                    <label htmlFor="branch_manager_bmid">Verified On
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control input-font"
                                                                        name="OTPverified_on"
                                                                        value={formData.OTPverified_on}
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>
                                                        <div className="col-md-2 print-only">

                                                            <div className="form-group ">
                                                                <label htmlFor="branch_manager_bmid">Verified By
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control input-font"
                                                                    name="OTPverified_on"
                                                                    value={formData.comp_name}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        
                                                {/* <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label className="myLabel">Route
                                                        </label>

                                                        <select
                                                            name="route"
                                                            id="route"
                                                            value={formData.route}
                                                            onChange={handleChange}
                                                            className="form-control input-font"
                                                            required
                                                        >
                                                            <option value="">-- Select --</option>
                                                            {routeList.map((item, index) => (
                                                                <option key={index} value={item.route_name}>
                                                                    {item.route_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {formData.route && (
                                                            <div className="branch-container ">
                                                                <span className="route-branches">
                                                                    Branches: {routeList.find(r => r.route_name === formData.route)?.branch_ids.join(", ")}
                                                                </span>
                                                            </div>
                                                        )}

                                                    </div>
                                                </div> */}
                                                <div className="row">
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label htmlFor="route_name"> Route
                                                            </label>
                                                            <select
                                                                name="route"
                                                                id="route"
                                                                value={formData.route}
                                                                onChange={handleChange}
                                                                className="form-control input-font"
                                                                required
                                                            >
                                                                <option value="">-- Select --</option>
                                                                {routeList.map((item, index) => (
                                                                    <option key={index} value={item.route_name} style={{ whiteSpace: 'pre-line' }}>
                                                                        {item.route_name}
                                                                    </option>
                                                                ))}
                                                            </select><br />
                                                             


                                                        </div>

                                                    </div>
                                                    <div className="row print-only">
                                                        <div className="col-md-4">

                                                            <div className="form-group print-only row">
                                                                <label className='col-sm-3'>Branches </label>
                                                                {/* <ul >
                                                                    {(routeList.find(r => r.route_name === formData.route)?.branch_ids || '')
                                                                        .toString()
                                                                        .split(",")
                                                                        .filter(id => id)
                                                                        .map(id => (
                                                                            <li key={id.trim()}>{id.trim()}</li>
                                                                        ))}
                                                                </ul> */}
                                                                        <div className='col-sm-9'>
                                                                            <ul >
                                                                                {(routeList.find(r => r.route_name === formData.route)?.branch_ids || '')
                                                                                    .toString()
                                                                                    .split(",")
                                                                                    .filter(id => id)
                                                                                    .map(id => (
                                                                                        <li key={id.trim()}>{id.trim()}</li>
                                                                                    ))}
                                                                            </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                   
                                                </div>
                                            </div>

                                        </fieldset>
                                        <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                            <center className='no-print'>
                                                <span className="btn btn-primary" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                    Additional Documents
                                                </span>
                                            </center>
                                            <div className="document-table-container" style={{ marginBottom: '20px', textAlign: 'right' }}>
                                                <table className="document-table" style={{ marginTop: '10px' }}>
                                                    <thead className='no-print'>
                                                        <tr>
                                                            <th style={{ textAlign: 'center' }}>Click to Preview</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* Loop through ImgRows and display each document's image */}
                                                        {ImgRows.length > 0 ? (
                                                            <tr>
                                                                <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                                        {ImgRows.map((document) => {
                                                                            // Construct the image URL outside the JSX expression
                                                                            const imageUrl = `${API_BASE_URL1}assets/uploads/${document.img}`;

                                                                            return (
                                                                                <div key={document.id} style={{ margin: '10px' }}>
                                                                                    <a href={imageUrl} target="_blank" rel="noopener noreferrer" className="position-relative">
                                                                                        {document.img.toLowerCase().endsWith('.pdf') ? (
                                                                                            // If the document is a PDF, show the PDF icon
                                                                                            <img
                                                                                                src={pdficon} // Replace with the actual path to your PDF icon
                                                                                                alt={`PDF Document ${document.id}`}
                                                                                                style={{
                                                                                                    width: '100px',
                                                                                                    height: '100px',
                                                                                                    objectFit: 'cover',
                                                                                                    margin: '5px',
                                                                                                }}
                                                                                            />
                                                                                        ) : (
                                                                                            // Otherwise, show the image
                                                                                            <img
                                                                                                src={imageUrl}
                                                                                                alt={`Document ${document.id}`}
                                                                                                style={{
                                                                                                    width: '79px',
                                                                                                    height: '100px',
                                                                                                    objectFit: 'cover',
                                                                                                    margin: '5px',
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </a>
                                                                                    <small className="text-center d-block mt-1 print-only">{document.img}</small>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                    {error ? error : 'No documents available.'}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </fieldset>


                                        <section className="col-lg-12 no-print">
                                            {uploadError && <div className="alert alert-danger text-center p-2">{uploadError}</div>}
                                            <label className="font-weight-bold">Upload Multiple Images:</label>
                                            <div className="custom-file mb-3">
                                                <input
                                                    type="file"
                                                    name="new_img"
                                                    multiple
                                                    accept="image/jpeg,image/jpg,image/png,application/pdf"
                                                    className="form-control"
                                                    onChange={handleFileChange}
                                                // Limit to 5 files
                                                />
                                                <small className="form-text text-muted">
                                                    Allowed formats: JPG, JPEG, PNG, PDF. Max size: 1MB per file. Max 5 files.
                                                </small>
                                            </div>
                                            {/* Show attached files count and badges */}
                                            {(ImgRows.length > 0 || (isFileAttached && formData.img.length > 0)) && (
                                                <div className="mt-2">
                                                    <span className="text-success">
                                                        <i className="fas fa-check-circle"></i>
                                                        {ImgRows.length > 0
                                                            ? `${ImgRows.length} file(s) already attached!`
                                                            : `${formData.img.length} file(s) attached successfully!`
                                                        }
                                                    </span>
                                                    <div className="mt-2">
                                                        {ImgRows.length > 0
                                                            ? ImgRows.map((_, index) => (
                                                                <span key={index} className="badge badge-info mr-2">
                                                                    File {index + 1}
                                                                </span>
                                                            ))
                                                            : formData.img.map((_, index) => (
                                                                <span key={index} className="badge badge-info mr-2">
                                                                    File {index + 1}
                                                                </span>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            )}
                                            <div className="text-center mt-3">
                                                {formData.is_submitted === 'No' &&
                                                    <>
                                                        <button
                                                            type="button"
                                                            className="btn btn-warning"
                                                            onClick={() => {
                                                                formData.is_submitted = 'No';
                                                                setIsFormSubmitted(true);
                                                                handleSubmit();
                                                            }}
                                                        >
                                                            Save as Draft
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-success ml-3"
                                                            onClick={() => {
                                                                formData.is_submitted = 'Yes'
                                                                setIsFormSubmitted(true);
                                                                handleSubmit();
                                                            }}
                                                            disabled={!isFileAttached || formData.img.length === 0}
                                                        >
                                                            {isSubmitting ? 'Submitting...' : 'Submit'}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-3"
                                                            onClick={handleBackClick}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </>
                                                }
                                                {(formData.is_submitted === 'Yes' && formData.isOTPverified === 'No') && (
                                                    <>
                                                        <button
                                                            type="button"
                                                            className="btn btn-success ml-3"
                                                            onClick={() => {
                                                                //  popup for OTP verification
                                                                popupOtpSent();
                                                            }}
                                                        >
                                                            Verify OTP
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-3"
                                                            onClick={handleBackClick}
                                                        >
                                                            Cancel
                                                        </button></>
                                                )}


                                            </div>
                                        </section>
                                    </form>

                                    <form class="row" onSubmit={handleSubmit}>
                                        <div className="col-md-3 no-print">
                                            {
                                                formData.is_submitted === 'Yes' && formData.isOTPverified === 'Yes' && (
                                                    <> <h5 className="text-success mt-3">

                                                        OTP Verified
                                                    </h5>
                                                        <button className='btn btn-sm btn-success no-print' onClick={handlePrint}>Print</button>
                                                    </>
                                                )

                                            }
                                        </div>
                                        {/* {((userBMID === formData.branch_manager_bmid || isUserITadmin === 'Y') && formData.isOTPverified === 'Yes') && (
                                            <>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="rpt_mgr_status">Manager Status
                                                           
                                                        </label>
                                                        <select
                                                            name="branch_manager_approval"
                                                            id="branch_manager_approval"
                                                            value={formData.branch_manager_approval}
                                                            onChange={handleChange}
                                                            className="form-control input-font"
                                                            required
                                                        >

                                                            <option value="Pending">Pending</option>
                                                            <option value="Approved">Approved</option>
                                                            <option value="Rejected">Rejected</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="remarks"> Remarks
                                                         
                                                        </label>

                                                        <textarea name="branch_manager_remarks"
                                                            id="branch_manager_remarks"
                                                            required
                                                            value={formData.branch_manager_remarks}
                                                            onChange={handleChange}
                                                            className="form-control "
                                                            placeholder="Remarks"></textarea>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mt-4">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-primary"
                                                            onClick={handleSubmit}

                                                        >
                                                            {isSubmitting ? 'Saving...' : 'Save'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        )} */}


                                    </form>
                                </div>
                            </div>
                        </section>
                    )}
                </div>
                <Footer />
            </div>
            <ToastContainer className={'no-print'}/>
        </div>

    );
}

export default EditVehicleTracking;
